import { useMemo } from 'react';

import { usePrivateWorkspaceAgentGuidedVariantClipSubjects } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/usePrivateWorkspaceAgentGuidedVariantClipSubjects';
import {
  getWorkspaceAgentGuidedVariantImagePreviewSelection,
  type WorkspaceAgentGuidedVariantImagePreviewSelection,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentGuidedVariantImagePreviewSelection';

export const usePrivateWorkspaceAgentGuidedVariantImageSelection =
  (): WorkspaceAgentGuidedVariantImagePreviewSelection => {
    const { clipSubjects } = usePrivateWorkspaceAgentGuidedVariantClipSubjects();

    return useMemo(() => getWorkspaceAgentGuidedVariantImagePreviewSelection(clipSubjects), [clipSubjects]);
  };
